import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AccountDownloadsPoliciesFragment = { __typename?: 'Account', id: string, resourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null, adminCanEnableInShares?: boolean | null, fullAccessCanEnableInShares?: boolean | null, editAndShareCanEnableInShares?: boolean | null, adminInternal?: boolean | null, fullAccessInternal?: boolean | null, editAndShareInternal?: boolean | null } | null } | null };

export type WorkspaceDownloadsPoliciesFragment = { __typename?: 'Workspace', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null } | null } | null, resourceControlPolicies?: { __typename?: 'WorkspaceResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null, adminCanEnableInShares?: boolean | null, fullAccessCanEnableInShares?: boolean | null, editAndShareCanEnableInShares?: boolean | null, adminInternal?: boolean | null, fullAccessInternal?: boolean | null, editAndShareInternal?: boolean | null } | null } | null };

export type ShareDownloadsPolicies_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canEnableDownloadsInShares?: boolean | null } | null } | null };

export type ShareDownloadsPolicies_CollectionShare_Fragment = { __typename?: 'CollectionShare', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null } | null } | null, permissions?: { __typename?: 'ProjectPermissions', canEnableDownloadsInShares?: boolean | null } | null } | null };

export type ShareDownloadsPoliciesFragment = ShareDownloadsPolicies_AdHocAssetsShare_Fragment | ShareDownloadsPolicies_CollectionShare_Fragment;

export const AccountDownloadsPolicies = /*#__PURE__*/ gql`
    fragment AccountDownloadsPolicies on Account {
  id
  resourceControlPolicies {
    downloads {
      shareDownloadingEnabled
      adminCanEnableInShares
      fullAccessCanEnableInShares
      editAndShareCanEnableInShares
      adminInternal
      fullAccessInternal
      editAndShareInternal
    }
  }
}
    ` as unknown as DocumentNode<AccountDownloadsPoliciesFragment, unknown>;
export const WorkspaceDownloadsPolicies = /*#__PURE__*/ gql`
    fragment WorkspaceDownloadsPolicies on Workspace {
  id
  appliedResourceControlPolicies {
    downloads {
      shareDownloadingEnabled
    }
  }
  resourceControlPolicies {
    downloads {
      shareDownloadingEnabled
      adminCanEnableInShares
      fullAccessCanEnableInShares
      editAndShareCanEnableInShares
      adminInternal
      fullAccessInternal
      editAndShareInternal
    }
  }
}
    ` as unknown as DocumentNode<WorkspaceDownloadsPoliciesFragment, unknown>;
export const ShareDownloadsPolicies = /*#__PURE__*/ gql`
    fragment ShareDownloadsPolicies on Share {
  id
  project {
    id
    appliedResourceControlPolicies {
      downloads {
        shareDownloadingEnabled
      }
    }
    permissions {
      canEnableDownloadsInShares
    }
  }
}
    ` as unknown as DocumentNode<ShareDownloadsPoliciesFragment, unknown>;

        

        
export const useAccountDownloadsPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<AccountDownloadsPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Account' } };
    return input;
  })();

  return useFragment<AccountDownloadsPoliciesFragment>({
    fragment: AccountDownloadsPolicies,
    fragmentName: 'AccountDownloadsPolicies',
    ...options,
  });
};
  
        
        

        
export const useWorkspaceDownloadsPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceDownloadsPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceDownloadsPoliciesFragment>({
    fragment: WorkspaceDownloadsPolicies,
    fragmentName: 'WorkspaceDownloadsPolicies',
    ...options,
  });
};
  
        
        

        
export const useShareDownloadsPoliciesFragment = (
  input: string | Omit<UseFragmentOptions<ShareDownloadsPoliciesFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareDownloadsPoliciesFragment>({
    fragment: ShareDownloadsPolicies,
    fragmentName: 'ShareDownloadsPolicies',
    ...options,
  });
};
  
        